import { render, staticRenderFns } from "./AddCalendar.vue?vue&type=template&id=134fefec&"
import script from "./AddCalendar.vue?vue&type=script&lang=js&"
export * from "./AddCalendar.vue?vue&type=script&lang=js&"
import style0 from "./AddCalendar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VDialog,VIcon})
